export default "/Frontend/dist/map-marker.a9b8a60a636e1deacceb512ebc4e2808.png";